import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { filterShownShipmentByDate } from "../../shipmentsSlice";
import { getUnixTime } from "../../../../helpers/time/convertApiTime";
import { useTranslation } from "react-i18next";

const getTimeValue = (date) => {
	const year = date.getFullYear();
	const month = date.getMonth() + 1;
	const day = date.getDate();
	return `${year}-${month}-${day}`;
}

const ShipmentsUpper = () => {
	const { t } = useTranslation()
	const dispatch = useDispatch();

	// Unix start 
	const [minDate, setMinDate] = useState(new Date(1970, 0, 1, 0, 0, 0, 0));
	// Date now
	const [maxDate, setMaxDate] = useState(new Date());

	const handleMinDateChange = (e) => {
		setMinDate(new Date(e.target.value));
	};
	const handleMaxDateChange = (e) => {
		setMaxDate(new Date(e.target.value));
	};

	useEffect(() => {
		dispatch(filterShownShipmentByDate({
			min: getUnixTime(minDate),
			// 86399000 = 23:59:59.000, so we can see all shipments of the day
			max: getUnixTime(maxDate) + 86399000
		}))
	}, [minDate, maxDate, dispatch])

    return (
        <div className="flex flex-col mb-2" >
			{/* Date inputs */}
            <div className="flex items-left sm:items-center flex-col sm:flex-row mb-6 sm:mb-8 md:mb-10">
                <span className="w-fit font-medium mr-4 text-md md:text-md lg:text-lg">
					{t("shipments.shipments_list.time_period.title")}: 
				</span>
				<div className='w-fit'>
					<input
						className="border-emerald-600 border-solid border-2 rounded p-1 text-2xs "
						type="date"
						onChange={handleMinDateChange}
					/>
					<span className="mx-3 text-xl">-</span>
					<input
						className="border-emerald-600 border-solid border-2 rounded p-1 text-2xs "
						type="date"
						onChange={handleMaxDateChange}
					/>
				</div>
            </div>
        </div>
    );
};

export default ShipmentsUpper;
